import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formDefaultsService } from '../services/formDefaults';

/**
 * Hook to manage displaying disclaimer on the first visible step
 * Shows disclaimer only on the first route the user visits in a session
 * Waits for routing to stabilize to ensure correct route tracking
 * 
 * @returns Object with shouldShow boolean
 */
export const useFirstStepDisclaimer = () => {
  const location = useLocation();
  const currentRoute = location.pathname.slice(1) || 'start';
  const [shouldShow, setShouldShow] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    // Only run once after routing has stabilized
    if (!hasInitialized) {
      // Use requestAnimationFrame to ensure we're after React's render cycle
      requestAnimationFrame(() => {
        // Check if no disclaimer has been shown yet
        const neverShown = formDefaultsService.shouldShowDisclaimer();
        
        if (neverShown) {
          // This is the first route being viewed - mark it and show disclaimer
          formDefaultsService.markDisclaimerShown(currentRoute);
          setShouldShow(true);
        } else {
          // Check if THIS route was the one that showed the disclaimer
          const wasShownHere = formDefaultsService.shouldShowDisclaimer(currentRoute);
          setShouldShow(wasShownHere);
        }
        
        setHasInitialized(true);
      });
    }
  }, [hasInitialized, currentRoute, location.pathname]);

  return {
    shouldShow
  };
};

